import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'SAP Business One',
  title: 'Integraciones SAP Business One con experiencia real.',
  subtitle:
    'Conectamos SAP Business One con tus aplicaciones, agentes de IA y servicios externos para que tu sistema central hable con todo tu ecosistema tecnológico.',
  tags: ['Service Layer', 'DI API', 'SAP HANA', 'SQL Server', 'AddOns', 'B2B'],
  blocks: [
    {
      icon: 'ri-links-line',
      title: 'Service Layer',
      desc: 'Integraciones modernas mediante la capa de servicios REST de SAP Business One.',
    },
    {
      icon: 'ri-terminal-box-line',
      title: 'DI API',
      desc: 'Automatización y desarrollo sobre la Data Interface API de SAP.',
    },
    {
      icon: 'ri-database-2-line',
      title: 'SAP HANA',
      desc: 'Consultas y optimización sobre bases de datos HANA para rendimiento real.',
    },
    {
      icon: 'ri-server-line',
      title: 'SQL Server',
      desc: 'Integración y reportes sobre instancias SQL Server de SAP Business One.',
    },
    {
      icon: 'ri-puzzle-2-line',
      title: 'AddOns',
      desc: 'Desarrollo de add-ons que extienden las capacidades de SAP Business One.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Automatización y B2B',
      desc: 'Sincronización y automatización de procesos entre SAP y sistemas externos.',
      items: ['Integraciones externas', 'APIs', 'Integraciones B2B'],
    },
  ],
  highlightTitle: 'Conectamos la IA con el corazón de tu empresa.',
  highlightDesc:
    'Una IA conectada a SAP Business One puede consultar clientes, stock, pedidos e indicadores en tiempo real, y ejecutar acciones dentro de tus procesos.',
};

export default function SapBusinessOne() {
  return <ServicePage content={content} />;
}